import React from "react";
import styled, { keyframes, css, RuleSet } from "styled-components";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Status } from "../../enums/Status";
import { Icon, IconContainer } from "../../components/visuals/styledComponents";
import {
  RowContainer,
  ElementContainer,
} from "../../components/containers/styledComponents";
import { CompassParagraph } from "../../components/common/styledComponents";
import fileIcon from "../../assets/svg/file_icon.svg";
import { compassLightGreen } from "../../styles";

// Keyframes for sliding gradient animation
const slide = keyframes`
  0% { background-position: 0% 50%; }
  100% { background-position: 100% 50%; }
`;

// Styled component for the gradient progress bar
const GradientProgressBar = styled(ProgressBar)<{ isLoading: boolean }>`
  width: 95%;
  height: 10px; // Customizable height
  background: linear-gradient(
    270deg,
    rgba(32, 226, 144, 1) 0%,
    rgba(32, 226, 144, 1) 10%,
    rgba(32, 226, 144, 1) 20%,
    rgba(32, 226, 144, 1) 30%,
    rgba(32, 226, 144, 1) 40%,
    rgba(236, 236, 236, 1) 50%,
    rgba(236, 236, 236, 1) 60%,
    rgba(236, 236, 236, 1) 70%,
    rgba(236, 236, 236, 1) 80%,
    rgba(236, 236, 236, 1) 90%,
    rgba(32, 226, 144, 1) 100%
  );
  background-size: 200% 200%;
  ${({ isLoading }): string =>
    isLoading ? "" : `background : ${compassLightGreen}`};
  animation: ${({ isLoading }): "none" | RuleSet<object> =>
    isLoading
      ? css`
          ${slide} 1.7s linear infinite
        `
      : "none"};
  transform: rotate(180deg);
`;

const FileLoadingCardContainer = styled.div`
  height: 150px;
  width: 100%;
  border: 1px solid ${compassLightGreen};
  border-radius: 12px;
  padding: 0px 5px;
`;

export const FileLoadingCard = ({
  file,
  status,
}: FileLoadingCardProps): JSX.Element => {
  return file && status !== Status.SUCCESS ? (
    <FileLoadingCardContainer>
      <RowContainer jc="flex-start" ai="center">
        <IconContainer size={60} m={1}>
          <Icon src={fileIcon} alt="file icon" />
        </IconContainer>
        <ElementContainer flexDirection="column" ml={15} mt={5}>
          <CompassParagraph bold={true} fontSize={16}>
            {file?.name}
          </CompassParagraph>
          <CompassParagraph>{Math.ceil(file?.size / 1000)} KB</CompassParagraph>
        </ElementContainer>
      </RowContainer>
      <RowContainer jc="center" mt={25}>
        <GradientProgressBar now={0} isLoading={status === Status.LOADING} />
      </RowContainer>
    </FileLoadingCardContainer>
  ) : (
    <></>
  );
};

type FileLoadingCardProps = {
  file: File | null;
  status: Status;
};
